import { Company } from "../gateway/Company/Company";

export class ConsultCompanyCnpjUsecase {
    constructor() {
        this.CompanyGateway = new Company();
    }

    async execute({ cnpj } = {}) {
        const payload = this.sanitizeInput({ cnpj });
        if (!payload.cnpj) return null;
        const response = await this.CompanyGateway.consultCnpj(payload);
        return response?.company || {};
    }

    sanitizeInput({ cnpj = "" } = {}) {
        const sanitizedCnpj = String(cnpj).trim();
        return { cnpj: sanitizedCnpj };
    }
}
